module.exports = __webpack_public_path__ + "img/empty_advert.2411b1da.svg";